import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { combineLatest } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { DynamicBarService } from 'src/app/_components/dynamic-bar/dynamic-bar.service';
import { GlobalService } from 'src/app/_services/global.service';
import { HorarioService } from 'src/app/_services/horario.service';
import { ThrobberService } from 'src/app/_services/throbber.service';

@Component({
  selector: 'app-horario-home',
  standalone: false,
  templateUrl: './horario-home.component.html',
  styleUrls: ['./horario-home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HorarioHomeComponent implements OnInit {

  data$ = this.horarioService.getHorarios();

  escuelas$ = this.globalService.tipoGenerico('TipoSeccionCurso').pipe(shareReplay(1));

  horarios$ = combineLatest([this.data$, this.escuelas$]).pipe(
    map(([data, escuelas]) => {
      return data.map(item => {
        item.escuelaNombre = escuelas.find(escuela => escuela.key === item.escuelaId).value;
        return item;
      });
    })
  );

  constructor (
    private title: Title,
    private dynamicBar: DynamicBarService,
    private horarioService: HorarioService,
    private globalService: GlobalService,
    private throberService: ThrobberService,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.title.setTitle('Inicio/Horario');
    this.dynamicBar.setBarra('barra-simple', {
      titulos: [
        { texto: 'Inicio', link: ['/'] },
        { texto: 'Horario', link: [] },
      ],
    });
  }

  eliminar(escuelaId, fechaInicio) {
    this.throberService.setThrobberState(true);
    this.horarioService.eliminarHorario(escuelaId, fechaInicio).subscribe(res => {
      this.throberService.setThrobberState(false);
      this.snackBar.open(`Se ha eliminado el horario.`, null, { duration: 2500 });
    });
  }

  ver() {

  }

}
